import Vue from 'vue'
import App from '@/App.vue'

import router from '@/boot/router.js';
import store from '@/boot/store.js';
import { i18n } from '@/boot/translation.js';

import { library } from '@fortawesome/fontawesome-svg-core';
// import { faMapMarkerAlt, faChartBar, faDatabase } from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faTwitter, faFacebook } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import '@ds/sass/core.scss';

library.add(faInstagram, faTwitter, faFacebook);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.config.productionTip = false;
new Vue({
	render: h => h(App),
	router,
	store,
	i18n
}).$mount('#app');